export default __webpack_public_path__ + "static/media/halls-5.7bf60bc1.webp";